import api from './api-config';
import { AdminUserDTO } from '../models/AdminUser';


interface UserCriteria {   
  page?: number;
  size?: number;
  sort?: string[];
}

export const adminUserService = {
  getAccount: async () => {
    const response = await api.get<AdminUserDTO>('/account');
    return response.data;
  },

  isAuthenticated: async () => {
    const response = await api.get<string>('/authenticate');
    return response.data;
  },

  logout: async () => {
    await api.post('/logout');
  },

  getManagedUsers: async (params?: UserCriteria) => {
    const response = await api.get<AdminUserDTO[]>('/managedusers', {
      params: {
        ...params,
        sort: params?.sort?.join(',')
      }
    });
    return response.data;
  },

  countUsers: async (params?: UserCriteria) => {
    const response = await api.get<number>('/countUsers', { params });
    return response.data;
  }, 

};